@if (isPercentageWorkLine()) {
  <app-work-line-percentage [workLine]="workLine"></app-work-line-percentage>
} @else if (isCableWorkLine()) {
  <app-work-line-cable [workLine]="workLine"></app-work-line-cable>
} @else {
  <app-work-line-quantity [workLine]="workLine"></app-work-line-quantity>
}

<!--<div [ngSwitch]="workLine.progressType">-->
<!--  <div *ngSwitchCase="0" >-->
<!--    <app-work-line-percentage [workLine]="workLine"></app-work-line-percentage>-->
<!--  </div>-->
<!--  <div *ngSwitchCase="1" >-->
<!--    <app-work-line-quantity [workLine]="workLine" [disabled]="disabled"></app-work-line-quantity>-->
<!--  </div>-->
<!--  <div *ngSwitchCase="2" >-->
<!--    <app-work-line-quantity [workLine]="workLine" ></app-work-line-quantity>-->
<!--  </div>-->
<!--  <div *ngSwitchDefault>-->
<!--    <app-work-line-quantity [workLine]="workLine" ></app-work-line-quantity>-->
<!--&lt;!&ndash;    Progress Type {{workLine.progressType}} Update in MIPS&ndash;&gt;-->
<!--  </div>-->
<!--</div>-->
